import { getAppConfig } from '@services/config';

const appConfig = getAppConfig();
export const envParams = {
    host: appConfig.tracking.host,
    debug: appConfig.tracking.debug,
    env: appConfig.tracking.env,
    site: 'Boutique',
    univers: 'Boutique_mobile',
    parcours: 'Acquisition',
    pageVariante: { pwa: 'oui', VariantePWA: 'V2' },
    ligneMarche: 'Mobile',
    structureClient: {},
    connexion: false,
};

export const tagHome = {
    id: 'Home',
    pageCategorie: 'Liste',
    page: 'Forfaits_sans_engagement',
    pageVariante: { Otis: 'forfaits_mobiles' },
    ligneMarche: 'Mobile',
    univers: 'Boutique_mobile',
};

export const tagHomeFai = {
    id: 'Home',
    pageCategorie: 'Liste',
    page: 'Fibre_sans_engagement',
    pageVariante: { Otis: 'offres_fibres' },
    ligneMarche: 'Fai',
    univers: 'Boutique_fai',
};
//   export const tagOptions = {
//     id: 'Options',
//     pageCategorie: 'Commande',
//     page: 'Cross_selling',
//     etapeEcommerce: '',
//   };
export const tagPanier = {
    id: 'Panier',
    pageCategorie: 'Commande',
    page: 'Panier',
    etapeEcommerce: 'Panier',
};

export const tagCoordonnees = {
    id: 'Coordonnees',
    pageCategorie: 'Commande',
    page: 'Coordonnees',
    etapeEcommerce: 'Checkout',
    // panier
    pageVariante: {
        pwa: 'oui',
        etapeCoordonnees: '',
    },
};

export const deliveryTag = {
    id: 'Livraison',
    page: 'Livraison',
    pageCategorie: 'Commande',
    etapeEcommerce: 'Checkout',
};

export const tagClickAddressNotFound = {
    actionClic: 'Clic_affichage',
    categorieClic: '',
    nomClic: 'Vous_ne_trouvez_pas_votre_adresse',
};

export const paymentTag = {
    id: 'Paiement',
    page: 'Paiement',
    pageCategorie: 'Commande',
    etapeEcommerce: 'Checkout',
};

export const tagPortabilityPage = {
    id: 'Conservation-de-votre-numero',
    page: 'Conservation_numero',
    pageCategorie: 'Commande',
    etapeEcommerce: 'Checkout',
    //panier
};
export const tagThanksPage = {
    id: 'Merci',
    page: 'Merci',
    pageCategorie: 'Commande',
    etapeEcommerce: 'Confirmation_commande',
    acte: 'Acquisition',
    categorieActe: 'Business',
    //panier
};
export const thanksRedirectionPage = {
    id: 'MerciRedirection',
    page: 'Redirection_cb',
    pageCategorie: 'Precommande',
    etapeEcommerce: 'Checkout',
    acte: 'Acquisition',
    categorieActe: 'Business',
    ligneMarche: 'Mobile',
};

export const tagScanIban = {
    actionClic: 'Clic_selection',
    categorieClic: 'Scan_iban',
    nomClic: 'telecharger votre IBAN',
};

export const tagGeolocalisation = {
    actionClic: 'Clic_affichage',
    categorieClic: 'Livraison_geolocalisation',
    nomClic: 'Localizez_vous',
};

export const tagsErrors = {
    ERR_MSG_API_RIO_NOT_ELIGIBLE: {
        page: 'Echec_code_rio',
        pageCategorie: 'Information',
        etapeEcommerce: '',
    },

    ERR_MSG_API_CREATION_COMPTE_INTERNALERROR: {
        page: 'Erreur_creation_compte',
        pageCategorie: 'Information',
        etapeEcommerce: '',
    },
};
